<template>
    <svg
    class="svgFilter"
        @click="clicked"
            @mouseout="mouseover"
            @mouseleave="mouseleave"
            @mouseenter="mouseenter"
            @mousedown="mousedown"
             width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    >  
   <path d="M1.49817 1C1.10467 1 0.886062 1.46817 1.06095 1.7959L6.48245 9.56758V15.4666C6.48245 15.8879 6.87595 16.122 7.22572 15.9347L9.23692 14.8579C9.41181 14.7643 9.49925 14.577 9.49925 14.3898V9.56758L14.9208 1.7959C15.1394 1.42136 14.877 1 14.4835 1H1.49817Z" stroke="black" stroke-miterlimit="10"/>
</svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style>
.svgFilter:hover path {
    stroke:#EF2035;
    stroke-width:2;
}
</style>